module.exports = __webpack_public_path__ + "img/category-Self-help.ef57bdd4.svg";